import { HrRed } from '@/components/styles/hr-styles';
import styled from 'styled-components';

export const ErrorContainer = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: ${(props) => props.color || HrRed};
`;
